/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Grid, Typography } from '@material-ui/core/'
import DeleteModal from './components/index'
import arrowBack from '../../assetss/img/arrowBack.svg'
import { LinearDeterminate } from 'components/UI/'
import api from '../../api/stoty'
import defaultBooksIcon from '../../assetss/img/defaultBooksIcon.svg'
import moment from 'moment'
import './index.scss'

const MyStory = () => {
  const [dataStories, setDataStories] = useState()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [idStory, setIdStory] = useState('')
  const { session } = useSelector(state => state)
  const history = useHistory()

  const goTo = path => history.push(path)
  const onDelete = () => {
    api.deleteStory(idStory, session?.user?.accessKey)
      .then(() => onOpenModal())
  }
  const onOpenModal = () => {
    setOpen(prev => !prev)
    setIdStory('')
  }

  useEffect(() => {
    if (session?.user?.accessKey) {
      api.getStorysById(session?.user?.user?.uuid)
        .then(res => {
          if (res?.data?.status === 'ok') {
            setLoading(false)
            setDataStories(res?.data?.stories?.map(item => item?.author?.uuid === session?.user?.user?.uuid ? item : null).filter(Boolean))
          }
        })
    }
  }, [session?.user?.accessKey, idStory])

  return (
    <Grid className='wrapperBookmarksContauner'>
      <Grid container className='bookmarksContauner' direction='column'>
        <Grid className='backStoryBox'>
          <Grid className='backBox' onClick={() => goTo('/')}>
            <img className='iconBack' src={arrowBack} /> Back
          </Grid>
        </Grid>
        <DeleteModal onDelete={onDelete} story open={open} onClose={onOpenModal} text='you story' />
        <Typography className='bookmarksTitle'>
          My stories
        </Typography>
        <Grid className='userStoriesContainer'>
          {dataStories?.length ? (
            dataStories?.map((i, ind) => (
              <Grid className='rowStory' container justify='space-between' key={i?.uuid}>
                <Grid className='imgContainerStory' onClick={() => goTo(`/story/${i?.uuid}`)}>
                  <img className='imgStory' src={i?.image?.src || defaultBooksIcon} />
                  <Typography className='storyTitle'>{i?.title}</Typography>
                </Grid>
                <Grid className='postedContainerStory'>
                  <Typography className='datePosted'>
                    Posted on {moment(+i?.createdAt).format('MMM D, h:mm A')}
                  </Typography>
                  <Typography
                    onClick={() => {
                      onOpenModal()
                      setIdStory(i?.uuid)
                    }}
                    className='deleteBtn'
                  >
                    Delete
                  </Typography>
                </Grid>
              </Grid>
            ))
          ) : (
            <div className='emptyTextStory'>Your sharing journey is yet to begin. Start sharing your stories!</div>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default MyStory
